import React, { Component } from 'react';
import { Button, Container, Col, Row } from 'react-bootstrap'
import { connect } from "react-redux";
import axios from "axios";
import configData from "../../config/config.json";
import { chevronRightIconBlue, envelopeIconBlack, mobileIcon } from "../../img/font_awesome/font_awesome"
import { LOADING_STATUES } from "../constants/constants";
import Confirmation from '../common/modal/Confirmation';
import translations from "../../config/translation/home_translations.json"

const mapStateToProps = state => {
  return {
    currentUser: state.currentUserReducer,
    language: state.languageReducer ? state.languageReducer : 'ENGLISH',
  };
}

const matchDispatchToProps = (dispatch) => {
  return {
    handleLockout: (lockout) => dispatch({ type: 'SET_LOCKOUT_IN_PLACE', lockout })
  }
}

class UserViewRow extends Component {

  state = {
    selectedId: '',
    selectedAlertName: '',
    showDeleteConfirmationDialog: false,
    loadingStatus: ""
  }

  showLoading = () => {
    if (this.state.loadingStatus === "") {
      this.setState({
        loadingStatus: LOADING_STATUES.LOADING
      })
      return true;
    }
    return false;
  }

  hideLoading = (message, status) => {
    if (status === 'ERROR') {
      this.setState({
        loadingStatus: "",
        submitMessage: ""
      })
    } else {
      this.setState({
        loadingStatus: "",
        submitMessage: message
      })
    }
  }

  // Delete methods

  handleDeleteAlert = () => {
    if (this.showLoading() === true) {
      axios.post(configData.LANDSHARK_SERVER_URL + "controlPanel/alertDelete", { accountId: this.state.selectedId, filterText: this.state.filterText, statusType: this.state.statusType }, { withCredentials: true })
        .then((response) => {
          this.setState({ filteredList: response.data.content.alerts, status: '' }, this.showAlert(response.data.message))
        }, (error) => {
          this.setState({ status: '' }, this.showWarning(error.response.data.message));
        });
      this.props.history.push('/controlPanel/alerts');
    }
  }

  showDeleteConfirmation = (event) => {
    let selectedId = event.target.closest('fieldset').id;
    let selectedAlertName = event.target.closest('fieldset').getAttribute('name');

    this.setState({
      selectedId,
      selectedAlertName,
      showDeleteConfirmationDialog: true
    })
  }

  hideDeleteConfirmation = () => {
    this.setState({
      showDeleteConfirmationDialog: false
    })
  }

  render() {

    let emailAddresses = [];
    this.props.emailAddressDTOs.forEach((emailAddressDTO) => {
      emailAddresses.push( <>{emailAddressDTO.verified === true ? <span>{emailAddressDTO.emailAddress}</span> : <span><s>{emailAddressDTO.emailAddress}</s></span>} </>)
    })

    let phones = [];
    this.props.phoneDTOs.forEach((phoneDTO) => {
      phones.push( <>{phoneDTO.verified === true && phoneDTO.validated === true ? <span>{phoneDTO.phoneNumber}</span> : <span><s>{phoneDTO.phoneNumber}</s></span>} </>)
    })

    return (
      <>
        <Container>
          <fieldset className="borderthick p-3" id={this.props.id} name={this.props.alertName} >
            <legend className="float-none w-auto" style={{ fontSize: '1.25rem', color: 'black' }} >{this.props.alertName}</legend>
            <Row style={{ paddingBottom: 10 }}>
              <Col lg={9} md={9} sm={9} xs={9}>
                <Container id={this.props.id} name={this.props.alertName}>
                  <Row>
                    <Col>
                      <strong>{translations[this.props.language].criteria}:</strong> {this.props.alertKey} ({this.props.alertType})
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={12} md={12} sm={12} xs={12}>
                      <span>{envelopeIconBlack}</span><span className="sr-only">Email Addresses</span> {emailAddresses}
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={12} md={12} sm={12} xs={12}>
                      <span style={{ paddingRight: 10 }}>{mobileIcon}</span><span className="sr-only">Phone Numbers</span>{phones}
                    </Col>
                  </Row>
                </Container>
              </Col>
              <Col lg={3} md={3} sm={3} xs={3} style={{ textAlign: 'right', paddingTop: 10 }}>
                <Button variant='link' onClick={this.props.onClick}>{chevronRightIconBlue}<span className="sr-only">Details</span> </Button>
              </Col>
            </Row>
          </fieldset>
        </Container>
        <Confirmation show={this.state.showDeleteConfirmationDialog} cancelConfirmation={this.hideDeleteConfirmation} proceedConfirmation={this.handleDeleteAlert} question={'Remove Alert ' + this.state.selectedAlertName + '?'} />

      </>
    )
  }
}

export default connect(mapStateToProps, matchDispatchToProps)(UserViewRow);